var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9833",
    "data-name": "Group 9833",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5492",
    "data-name": "Rectangle 5492",
    width: 24,
    height: 20,
    fill: "#e62e2e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9834",
    "data-name": "Group 9834",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27969",
    "data-name": "Path 27969",
    d: "M9.438,7.055A1.147,1.147,0,0,1,8.2,8.267,1.121,1.121,0,0,1,7.016,7.016,1.113,1.113,0,0,1,8.24,5.854a1.144,1.144,0,0,1,1.2,1.2",
    fill: "#1D1D26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27970",
    "data-name": "Path 27970",
    d: "M17.012,7.07a1.157,1.157,0,0,1-1.21,1.2,1.114,1.114,0,0,1-1.217-1.194A1.2,1.2,0,0,1,15.642,5.86a1.176,1.176,0,0,1,1.37,1.21",
    fill: "#1D1D26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27971",
    "data-name": "Path 27971",
    d: "M22.76,5.854a1.109,1.109,0,0,0-1.053.587H20.584V3a3,3,0,0,0-3-3H6.435a3,3,0,0,0-3,3V6.441H2.276a1.144,1.144,0,0,0-1.05-.587A1.114,1.114,0,0,0,0,7.016,1.122,1.122,0,0,0,1.186,8.267a1.165,1.165,0,0,0,1.092-.586H3.432v5.257a3,3,0,0,0,3,3H7.895v2.8a1.252,1.252,0,0,0,2.121.9l3.853-3.707h3.712a3,3,0,0,0,3-3V7.681h1.123a1.12,1.12,0,0,0,1.084.586A1.156,1.156,0,0,0,24,7.07a1.162,1.162,0,0,0-1.24-1.216m-4.411,3.6a1.447,1.447,0,0,1-1.436,1.433q-4.927.029-9.855,0a1.388,1.388,0,0,1-1.38-1.352c-.033-1.706-.014-3.414.018-5.12a1.168,1.168,0,0,1,.953-1.125,4.3,4.3,0,0,1,.777-.062c1.53,0,3.061,0,4.591,0,1.551,0,3.1,0,4.653,0a1.69,1.69,0,0,1,1.682,1.691c0,1.513.006,3.025,0,4.538",
    fill: "#1D1D26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGptIcon);
export default __webpack_public_path__ + "static/media/GptIcon.a3abd09268b5b15973e224da0c88573f.svg";
export { ForwardRef as ReactComponent };